/**
 * Fotos, laudos e termos são servidos pela própria API (caminhos que começam com /public/).
 * Aqui montamos a URL completa usando o endereço da API do ambiente.
 */
const apiBase = (process.env.REACT_APP_API_ENDPOINT || '').replace(/\/$/, '');

export const assetUrl = (path?: string) =>
  path && path.startsWith('/') ? `${apiBase}${path}` : path || '';

export default assetUrl;
